module.exports = __webpack_public_path__ + "img/home_carte.39779381.jpg";